import { render } from "./SrcBackgroundScroll.vue?vue&type=template&id=8f2e296e"
import script from "./SrcBackgroundScroll.vue?vue&type=script&lang=js"
export * from "./SrcBackgroundScroll.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\Vue_Webinterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__